import { ReactNode, FC } from 'react';
import { SharedTooltip } from '../../shared/SharedTooltip';
import styles from './PdpRespSidebarSellerInfoTooltip.scss';

type Props = {
    title?: ReactNode;
    ariaLabel?: string;
    description: ReactNode;
    dataTn?: string;
    linkClass?: string;
    wrapperClass?: string;
};

export const PdpRespSidebarSellerInfoTooltip: FC<Props> = ({
    title,
    ariaLabel,
    description,
    dataTn,
    wrapperClass,
    linkClass,
    children,
}) => {
    return (
        <SharedTooltip
            ariaLabel={ariaLabel}
            wrapperClass={wrapperClass}
            linkClass={linkClass}
            dataTn={dataTn}
            align="right"
            direction="bottom"
            tooltipContent={
                <>
                    {title && <span className={styles.title}>{title}: </span>}
                    {description}
                </>
            }
        >
            {children}
        </SharedTooltip>
    );
};
